import { useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import { Toaster } from "../components/ui/sonner";
import { AuthProvider } from "../contexts/auth.context";
import { AuthDialog } from "../components/auth/auth-dialog";
import { applyAuthToFetchArgs, handleUnauthorizedResponse } from "../lib/fetcher";
import { routes } from "../routes";
import { LocaleBootstrap } from "../i18n";
import "./global.css";

const App: React.FC = () => {
	const element = useRoutes(routes);
	const [authDialogOpen, setAuthDialogOpen] = useState(false);

	useEffect(() => {
		if (typeof window === "undefined") {
			return;
		}

		const originalFetch = window.fetch.bind(window);
		window.fetch = (async (input: RequestInfo | URL, init?: RequestInit) => {
			const [nextInput, nextInit] = await applyAuthToFetchArgs(input, init);
			const response = await originalFetch(nextInput, nextInit);
			if (response.status === 401) {
				await handleUnauthorizedResponse(response);
			}
			return response;
		}) as typeof fetch;

		return () => {
			window.fetch = originalFetch;
		};
	}, []);

	return (
		<AuthProvider>
			<LocaleBootstrap />
			{element}
			<AuthDialog open={authDialogOpen} onOpenChange={setAuthDialogOpen} />
			<Toaster />
		</AuthProvider>
	);
};

export default App;
